import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "../components/ui/button";

const LegalNoticePage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#111111] text-white px-6 md:px-12 lg:px-24 py-12">
      <div className="max-w-4xl mx-auto">
        <Button
          variant="ghost"
          className="mb-6 text-zinc-400 hover:text-white"
          onClick={() => navigate("/")}
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back
        </Button>

        <h1 className="text-3xl md:text-4xl font-bold mb-6">Legal Notice</h1>
        <p className="text-zinc-400 mb-8">Last update: 29 April 2026</p>

        <div className="space-y-6 text-zinc-300 leading-7">
          <section>
            <h2 className="text-xl font-semibold text-white mb-2">Editor</h2>
            <p>Brand: SaaS-Radar</p>
            <p>Location: Landshut, Bayern</p>
            <p>Publication manager: saas.radar.business@gmail.com</p>
            <p>Legal contact: saas.radar.business@gmail.com</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-2">Legal form and registration</h2>
            <p>No legal form and no SIREN/SIRET provided at this stage.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-2">Hosting</h2>
            <p>Infrastructure may rely on cloud providers including Vercel, Render, and Supabase.</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default LegalNoticePage;
